import React from 'react';

interface ProductFormLayoutProps {
  children: React.ReactNode;
  sidebar: React.ReactNode;
}

/**
 * Two-column layout for the product editor
 * Left column (8.5 units): Main content cards
 * Right column (3.5 units): Sticky sidebar with preview
 */
export const ProductFormLayout: React.FC<ProductFormLayoutProps> = ({ children, sidebar }) => {
  return (
    <div className="w-full min-h-[calc(100vh-140px)] pb-8">
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[8.5fr_3.5fr]">
        {/* Main content column */}
        <div className="flex flex-col gap-5">{children}</div>

        {/* Sidebar column */}
        <div className="flex flex-col gap-5 lg:sticky lg:top-20 lg:self-start">{sidebar}</div>
      </div>
    </div>
  );
};
